module.exports = __webpack_public_path__ + "img/会社案内.8fc729ab.png";